let map = {
	'lumand.com': 'prod'
  , 'www.lumand.com': 'prod'
  , 'prod.localhost': 'prod'
  , 'test.lumand.com': 'test'
  , 'test.localhost': 'test'
  , 'greg.localhost': 'dev-greg1'
  , 'dima.localhost': 'dev-dima'
  , 'dimatest.localhost': 'test_dima'
}
let env  = map[window.location.hostname] || 'dev'
export default env



// WEBPACK FOOTER //
// ./src/utils/env.js